import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './app/app.jsx';

import store from './store';
import history from './history';
import 'assets/scss/material-dashboard-pro-react.css?v=1.2.0';

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Switch>
        <App />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('root')
);
